import { SIMPANAN_HARI_RAYA } from "../../constants/admin/masterdata/constants";

const initialState = {
  isModalAction: false,
  loadingGetSimpananHariRaya: true,
  loadingActionSimpananHariRaya: false,
  dataSimpananHariRaya: { count: 0, data: [] },
  selectedIds: [],
  queryKey: null,
  cache: {}, 
};

export const simpananHariRayaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIMPANAN_HARI_RAYA.GET_DATA_SIMPANAN_HARI_RAYA_SUCCESS:
      return {
        ...state,
        dataSimpananHariRaya: action.data,
      };

    case SIMPANAN_HARI_RAYA.LOADING_DATA_SIMPANAN_HARI_RAYA_SUCCESS:
      return {
        ...state,
        loadingGetSimpananHariRaya: action.load,
      };

    case SIMPANAN_HARI_RAYA.LOADING_ACTION_SIMPANAN_HARI_RAYA:
      return {
        ...state,
        loadingActionSimpananHariRaya: action.load,
      };

    case SIMPANAN_HARI_RAYA.IS_MODAL_ACTION_SIMPANAN_HARI_RAYA:
      return {
        ...state,
        isModalAction: action.load,
      };

    // Selection
    case SIMPANAN_HARI_RAYA.SET_QUERY_KEY: {
      if (state.queryKey !== action.key) {
        return { ...state, queryKey: action.key, selectedIds: [] };
      }
      return state;
    }

    case SIMPANAN_HARI_RAYA.ADD_SELECTED_IDS: {
      const set = new Set(state.selectedIds);
      (action.ids || []).forEach((id) => set.add(id));
      return { ...state, selectedIds: Array.from(set) };
    }

    case SIMPANAN_HARI_RAYA.REMOVE_SELECTED_IDS: {
      const removeSet = new Set(action.ids || []);
      const next = state.selectedIds.filter((id) => !removeSet.has(id));
      return { ...state, selectedIds: next };
    }

    case SIMPANAN_HARI_RAYA.CLEAR_SELECTED_IDS:
      return { ...state, selectedIds: [] };

    case SIMPANAN_HARI_RAYA.SET_CACHE_ENTRY:
      return {
        ...state,
        cache: {
          ...state.cache,
          [action.key]: {
            data: action.data,
            timestamp: Date.now(),
          },
        },
        dataSimpananHariRaya: action.data, 
      };

    case SIMPANAN_HARI_RAYA.UPDATE_CACHE_ITEMS: {
      const { changesById } = action;

      const updatedCache = { ...state.cache };
      Object.keys(updatedCache).forEach((key) => {
        if (updatedCache[key]?.data?.data) {
          updatedCache[key] = {
            ...updatedCache[key],
            data: {
              ...updatedCache[key].data,
              data: updatedCache[key].data.data.map((item) =>
                changesById[item.id]
                  ? { ...item, ...changesById[item.id] }
                  : item,
              ),
            },
          };
        }
      });

      const currentData = state.dataSimpananHariRaya?.data || [];
      const updatedData = currentData.map((item) =>
        changesById[item.id] ? { ...item, ...changesById[item.id] } : item,
      );

      return {
        ...state,
        cache: updatedCache,
        dataSimpananHariRaya: {
          ...state.dataSimpananHariRaya,
          data: updatedData,
        },
      };
    }

    case SIMPANAN_HARI_RAYA.WITHDRAWAL_ACTION_COMPLETED: {
      const { processedIds, newStatus } = action.payload;

      const removeSet = new Set(processedIds || []);
      const nextSelectedIds = state.selectedIds.filter(
        (id) => !removeSet.has(id),
      );

      const activeList = state.dataSimpananHariRaya?.data || [];
      const newActive = activeList.map((row) =>
        (processedIds || []).includes(row.id)
          ? { ...row, status: newStatus }
          : row,
      );

      return {
        ...state,
        selectedIds: nextSelectedIds,
        dataSimpananHariRaya: {
          ...state.dataSimpananHariRaya,
          data: newActive,
        },
      };
    }

    case SIMPANAN_HARI_RAYA.WITHDRAWAL_ACTION_FAILED: {
      return {
        ...state,
        loadingActionSimpananHariRaya: false,
      };
    }

    case SIMPANAN_HARI_RAYA.DATA_REFRESH_REQUESTED: {
      return {
        ...state,
        loadingGetSimpananHariRaya: true,
      };
    }

    default:
      return state;
  }
};
